import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ButtonLink from '../utility/ButtonLink';
import { withTranslation } from 'react-i18next';
import iconDriver from '../../images/icons/icon_driver.png';
import iconPax from '../../images/icons/icon_32_noofpax.png';

class TravelCompanions extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      companions,
      uuid,
      isEditable,
      bookingCode,
      t,
    } = this.props;

    return (
      <section className="fe-my-booking-info-companions">
        <div className="container">
          <div className="row"> 
            <div className="col-xl-8">
              <div className="fe-my-booking-preinfo">
                <div className="fe-my-booking-id">
                  {`${t('trip:bookingId')}: ${bookingCode}`}
                </div>
              </div>
              <h4 className="fe-trip-main-heading">{t('trip:travelCompanions')}</h4>
              <div className="fe-my-booking-companions">
                {companions.map((companion, idx) => {
                  return (
                    <div key={idx} className="fe-my-companion-item-container">
                      <div className="fe-my-companion-item">
                        <img src={companion.is_driver ? iconDriver : iconPax} alt=""/>
                        <div className="fe-my-companion-item-info">
                          <div className="fe-my-companion-role">{companion.is_driver ? t('gen:driver') : t('gen:companion')}</div>
                          <div className="fe-my-companion-name">
                            { companion.name || <span>{t('trip:detailToFill', { detail: t('form:name') })}</span> }
                          </div>
                          <div className="fe-my-companion-mobile">
                            { companion.mobile_no || <span>{t('trip:detailToFill', { detail: t('form:mobileNo') })}</span> }
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          {isEditable ?
            <ButtonLink
              alt
              to={`/your-bookings/edit/${uuid}`}
            >
              {t('form:editDetails')}
            </ButtonLink> : null}
        </div>
      </section>
    );
  }
}

TravelCompanions.propTypes = {
  companions: PropTypes.array.isRequired,
  uuid: PropTypes.string.isRequired,
  isEditable: PropTypes.bool,
  t: PropTypes.func.isRequired,
  bookingCode: PropTypes.string.isRequired,
};

export default withTranslation()(TravelCompanions);